

import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentStore, fetchDataMotorCycle } from '../../features/dashboard/DocumentSlice';
import { archiveIndex } from '../../features/dashboard/ArchiveSlice';
import { sectionOneSearch, sectionTwoSearch, sectionThreeSearch } from '../../features/dashboard/SectionSlice';
import { fetchDocumentStatus } from '../../features/dashboard/DocumentStatusSlice'
import Loading from '../../Loading';
import Spinner from '../../Spinner';
import Header from '../../component/dashboard/Header';
import Input from '../../component/form/Input';
import InputRef from '../../component/form/InputRef';
import Select from '../../component/form/Select';
import Button from '../../component/form/Button';
import style from './document.module.css';
import { setLocale } from 'yup';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { ToastContainer, toast } from 'react-toastify';
import Message from '../form/Message'
import MainLayout from '../Layout';
import Broadcast from './Broadcast';
import axios from 'axios';
import * as moment from 'jalali-moment';
import { host } from '../../function/api'
import $ from 'jquery'


function Document() {

    const dispatch = useDispatch();
    // serach variable state
    // const [documentNumber, setDocumentNumber] = useState('')
    const [number, setNumber] = useState('')
    const [numberType, setNumberType] = useState('mt_pelakno')
    // set fetch data from kavir state
    const tp_karbari = useRef('')
    const tp_tip = useRef('')
    const cl_name = useRef('')
    const mt_model = useRef('')
    const tp_system = useRef('')
    const mt_bodyno = useRef('')
    const mt_motorno = useRef('')
    const mt_pelakno = useRef('')
    const mt_sanadno = useRef('')
    const fc_coname = useRef('')
    const tp_mehvar = useRef('')
    const tp_charkh = useRef('')
    const tp_zarfiyat = useRef('')
    const tp_cylandr = useRef('')
    const tp_sookht = useRef('')
    const tp_hajm = useRef('')
    const mt_pelakserial = useRef('')
    const mt_pelakdate = useRef('')
    // set customer state
    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [mobile, setMobile] = useState('')
    const [description, setDescription] = useState('')
    // data set variables
    const [transferToStore, setTransferToStore] = useState('')
    const [status, setStatus] = useState(false)
    const [section, setSection] = useState('')
    const [sectionId, setSectionId] = useState('')
    const [partone, setPartone] = useState('')
    const [parttwo, setParttwo] = useState('')
    const [partthree, setPartthree] = useState('')
    const [RahpardaznetSectionOne, setRahpardaznetSectionOne] = useState('')
    const [RahpardaznetSectionTwo, setRahpardaznetSectionTwo] = useState('')
    const [RahpardaznetSectionMain, setRahpardaznetSectionMain] = useState('')
    const [RahpardaznetDetailsData, setRahpardaznetDetailsData] = useState({})
    const [RahpardaznetMessage, setRahpardaznetMessage] = useState('')
    
    const [MainWarehouse, setMainWarehouse] = useState('0')
 
    let {
        documentData,
        errorName,
        errorFamily,
        errorNationalCode,
        errorNumber,
        errorNumberType,
        errorTransferToStore,
        errorDescription,
        errorStatus,
        errorMobile,
        errorPartOne,
        errorPartTwo,
        errorPartThree,
        error_mt_bodyno,
        error_mt_motorno,
        error_mt_pelakno,
        error_mt_sanadno
    } = useSelector(state => state.document)

    const token = localStorage.getItem('token')

    const {
        loading,
        success,
        error,
        message,
        store,
        reload,
        NewDocumentError
    } = useSelector(state => state.document)

    const { archives } = useSelector(state => state.archive)
    const { statuses } = useSelector(state => state.status)
    const { sections, partOne, partTwo } = useSelector(state => state.section)
    // data variable to document slice

    const rahpardaznetChangeStore = async (event) => {
        event.preventDefault()
        if(typeof documentData.sections == 'object' || documentData.sections.length > 0){
            if(!MainWarehouse || MainWarehouse == '0'){
                $('html, body').animate({
                    scrollTop: $(".rahpardaznet-main-warehouse").offset().top
                }, 500);
                toast.error("انبار اصلی را انتخاب کنید.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }

        }

        const data = {
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'main_warehouse': MainWarehouse
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/changeStore`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("انبار اصلی سند با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                
                
            }

        } catch (error) {
            
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 1200,
            })
        }

    }
    const documentStoreHandler = (event) => {
        event.preventDefault();
        if(typeof documentData.sections == 'object' && documentData.sections.length > 0){
            if(!MainWarehouse || MainWarehouse == '0'){
                $('html, body').animate({
                    scrollTop: $(".rahpardaznet-main-warehouse").offset().top
                }, 500);
                toast.error("انبار اصلی را انتخاب کنید.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }

        }
        const data = {
            'tp_karbari': tp_karbari.current.innerHTML,
            'tp_tip': tp_tip.current.innerHTML,
            'cl_name': cl_name.current.innerHTML,
            'mt_model': mt_model.current.innerHTML,
            'tp_system': tp_system.current.innerHTML,
            'mt_bodyno': mt_bodyno.current.innerHTML,
            'mt_motorno': mt_motorno.current.innerHTML,
            'mt_pelakno': mt_pelakno.current.innerHTML ? mt_pelakno.current.innerHTML : documentData.mt_pelakno,
            'mt_sanadno': mt_sanadno.current.value ? mt_sanadno.current.value : documentData.mt_sanadno,
            'tp_mehvar': tp_mehvar.current.innerHTML,
            'tp_charkh': tp_charkh.current.innerHTML,
            'tp_zarfiyat': tp_zarfiyat.current.innerHTML,
            'tp_cylandr': tp_cylandr.current.innerHTML,
            'tp_sookht': tp_sookht.current.innerHTML,
            'tp_hajm': tp_hajm.current.innerHTML,
            'mt_pelakserial': mt_pelakserial.current.innerHTML,
            'mt_pelakdate': mt_pelakdate.current.innerHTML,
            'fc_coname': fc_coname.current.innerHTML,
            // 'name': name,
            // 'family': family,
            // 'nationalCode': nationalCode,
            // 'mobile': mobile,
            // 'description': description,
            'status': status,
            // 'store_id': transferToStore,
            // 'section_id': sectionId,
            // 'part_one': partone,
            // 'part_two': parttwo,
            // 'part_three': partthree,
            'main_warehouse': MainWarehouse
        }
        // setStatus(true)
        dispatch(documentStore(data));

    }
    useEffect(() => {




        if (loading === true)
            document.body.style.overflow = "hidden"
        if (loading === false)
            document.body.style.overflow = "auto"
        return () => {
            documentData = null
        }
    }, [loading])

    useEffect(() => {
        if (reload === true) {
            const data = {
                'numberType': numberType,
                'number': number
            }
            dispatch(fetchDataMotorCycle(data));
            setNumberType('mt_pelakno');
            setNumber('');
            $('#SearchNumber').val('');
            $('#SearchNumberType').val('');
        }
    }, [reload])



    useEffect(() => {
        setNumber('')
    }, [numberType])
    useEffect(() => {
        console.log(success);
        if(loading === false && !NewDocumentError && documentData){
 
            if (typeof documentData == 'object') {
            if(Object.keys(documentData).length != 0){
                setMainWarehouse(documentData.main_warehouse);
            }
               



            }
        }

        if (!NewDocumentError && message) {


            toast.success(message, {
                position: "top-center",
                autoClose: 5000,
            })
            $('#SearchNumber').val('');
            $('#SearchNumberType').val('');
        } else if (NewDocumentError && message) {
            toast.error(message, {
                position: "top-center",
                autoClose: 5000,
            })

        }
    }, [message, success, loading, documentData, NewDocumentError])




    useEffect(() => {
        if (documentData && documentData.length != 0) {
            if (documentData.status_document_id) {
                getDocumentDetails();
            }

            if (documentData.store_id && !RahpardaznetSectionMain) {
                console.log(documentData.store_id);
                let value = documentData.store_id;
                setTransferToStore(value)
                const searchItem = {
                    'store_id': value
                }
                setRahpardaznetSectionMain('1');
                dispatch(sectionOneSearch(searchItem))
            }

            if (documentData.section_one && !RahpardaznetSectionOne) {
                console.log(documentData.section_one);
                setPartone(documentData.section_one)
                const partOneItem = {
                    'section_one_id': documentData.section_one,
                }
                setRahpardaznetSectionOne('1');
                dispatch(sectionTwoSearch(partOneItem));
            }

            if (documentData.section_two && !RahpardaznetSectionTwo) {
                console.log(documentData.section_two);
                setParttwo(documentData.section_two)
                const partTwoItem = {
                    'section_two_id': documentData.section_two,
                }
                setRahpardaznetSectionTwo('1');
                dispatch(sectionThreeSearch(partTwoItem));

            }
            if (documentData.section_three) {
                console.log(documentData.section_three);
                setPartthree(documentData.section_three);
            }
            if (documentData.status_document_id) {
                setStatus(documentData.status_document_id);
            } else {
                setStatus('');
            }
        }

    }, [archives, sections, documentData]);


    const transferStoreHandler = (value) => {
        setTransferToStore(value)
        const searchItem = {
            'store_id': value
        }
        dispatch(sectionOneSearch(searchItem))
    }

    const sectionOneSearchHandler = (value) => {
        setPartone(value)
        const partOneItem = {
            'section_one_id': value,
        }
        dispatch(sectionTwoSearch(partOneItem));
    }

    const sectionTwoSearchHandler = (value) => {
        setParttwo(value)
        const partTwoItem = {
            'section_two_id': value,
        }
        dispatch(sectionThreeSearch(partTwoItem));
    }



    const dataMotorCycleHandler = (e) => {
        e.preventDefault();
        const data = {
            'numberType': numberType,
            'number': number
        }
        dispatch(fetchDataMotorCycle(data));
        dispatch(archiveIndex(token))
        dispatch(fetchDocumentStatus(token))
        if (documentData && documentData.length != 0) {


            if (documentData.store_id) {
                console.log(documentData.store_id);
                let value = documentData.store_id;
                setTransferToStore(value)
                const searchItem = {
                    'store_id': value
                }
                dispatch(sectionOneSearch(searchItem))
            }

            if (documentData.section_one) {
                console.log(documentData.section_one);
                setPartone(documentData.section_two)
                const partOneItem = {
                    'section_one_id': documentData.section_two,
                }
                dispatch(sectionTwoSearch(partOneItem));
            }

            if (documentData.section_two) {
                console.log(documentData.section_two);
                setParttwo(documentData.section_two)
                const partTwoItem = {
                    'section_two_id': documentData.section_two,
                }
                dispatch(sectionThreeSearch(partTwoItem));

            }
            if (documentData.section_three) {
                console.log(documentData.section_three);
                setPartthree(documentData.section_three);
            }
            if (documentData.status_document_id) {
                console.log(documentData.status_document_id);
                setStatus(documentData.status_document_id);
            }


        }
    }

    const [value, setValue] = useState(new Date())




    const getDocumentDetails = async () => {

        try {

            const data = {
                'mt_sanadno': mt_sanadno.current.innerHTML,
                'status': '00',
            }
            const response = await axios({
                method: 'post',
                url: `${host}document/details`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            setRahpardaznetDetailsData(response.data.data);

        } catch (error) {
            toast.error("خطایی پیش آمد مجددا تلاش نمایید.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };



    const RahpardaznetSubmitMessage = async (e) => {
        e.preventDefault()
        if (RahpardaznetMessage == null || RahpardaznetMessage == " ") {
            toast.error("یادداشت خالی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        // alert(RahpardaznetMessage);
        const data = {
            'message': RahpardaznetMessage,
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'status_id': '00'
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/message`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success('یادداشت با موفقیت ایجاد شد.', {
                    position: "top-center",
                    autoClose: 1200,
                })
                getDocumentDetails();
                $(".rahpardaznet-list-message").animate({
                    scrollTop: $('.rahpardaznet-list-message').get(0).scrollHeight
                }, 1500);
                setRahpardaznetMessage(' ');

            }

        } catch (error) {
            toast.error("یادداشت اضافه نشد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };

    useEffect(() => {
        $("#rahpardaznet-image-file").fileinput({
            theme: 'fa',
            uploadUrl: `${host}document/status/upload-image`,
            uploadExtraData: function () {
                return {
                    'code': mt_sanadno.current.innerHTML,
                    'mt_sanadno': mt_sanadno.current.innerHTML,
                    'statusid': '0'
                };
            },
            allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
            overwriteInitial: false,
            maxFileSize: 2048,
            maxFilesNum: 10
        });
    }), [];

    const RahpardaznetDefaultNote = (message) => {
        setRahpardaznetMessage(RahpardaznetMessage + " " + message);
    }
    return (
        <>

            {loading ? (<Loading />) : null}
            <Broadcast title={'ثبت سند جدید'} />

            <form className="text-end">
                <div className='row rahpardaznet-cart  print-position'>
                    <Header title={'ثبت سند جدید'} />
                    <div className="col-12">
                        <div className='rahpardaz-search-form-select'>

                            <select

                                value={numberType}
                                id="SearchNumberType"
                                defaultValue={'mt_pelakno'}
                                onChange={(e) => setNumberType(e.target.value)}
                                className="form-control form-select form-select-lg shadow-none"
                                aria-label="form-select-lg example">
                                <option value='DEFAULT' selected disabled>یک مورد را انتخاب کنید</option>
                                <option value='mt_pelakno'>شماره پلاک</option>
                                <option value='mt_bodyno'>شماره شاسی</option>
                                <option value='mt_sanadno'>شماره سند</option>
                            </select>


                            {
                                numberType === 'mt_pelakno' ? (
                                    <Input
                                        key='2'
                                        tab='2'
                                        col='col-12'
                                        type='text'
                                        maxLength={25}
                                        name='number'
                                        value={number ? number : null}
                                        onchange={(e) => setNumber(e.target.value)}
                                        placeholder='شماره پلاک را وارد نمایید.'
                                        dash="SearchNumber"
                                        error={errorNumber}
                                        focus='1'
                                        keyup={true}

                                    />
                                ) : (
                                    <Input
                                        key='2'
                                        tab='2'
                                        col='col-12'
                                        type='text'
                                        name='number'
                                        value={number ? number : null}
                                        onchange={(e) => setNumber(e.target.value)}
                                        placeholder='شماره شاسی یا سند را وارد نمایید.'
                                        dash="SearchNumber"
                                    />


                                )

                            }

                            <Button
                                tab='14'
                                title='استعلام سند'
                                event={dataMotorCycleHandler}
                            />

                        </div>
                        {
                            (errorNumberType) ? (
                                <span className="help-block d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{errorNumberType}</small>
                                </span>
                            ) : ''}
                        {
                            (errorNumber) ? (
                                <span className="help-block d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{errorNumber}</small>
                                </span>
                            ) : ''}
                        {/* {
                           (documentData && documentData.length != 0 &&  message)  ? (
                                <h6 className='text-end text-muted mt-3 mb-0'>
                                    <i className="fa-regular fa-bell fa-lg fa-fw fa-stack"></i>
                                    {message}
                                </h6>
                            ) : null
                        } */}
                    </div>
                </div>

            </form>
            {
                (typeof documentData === 'undefined') ? null :
                    (Object.keys(documentData).length != 0) ? (
                        <form>
                            <div className='row rahpardaznet-cart  my-5  print-position'>

                                <Header title='اطلاعات انبار' />
                                <div>

                                    {
                                        (typeof documentData.sections == 'object' && documentData.sections.length > 0) ? (
                                            <>
                                                {
                                                    documentData.sections.map((section, key) => (
                                                        <div className={MainWarehouse == section.section_main.id ? 'active-main-warehouse col-12 d-flex rahpardaznet-section-box' : 'section col-12 d-flex rahpardaznet-section-box'}>
                                                            <div className='rahpardaznet-section section-main'>{section.section_main.name}</div>
                                                            <div className='rahpardaznet-section section-one'>{section.section_one.name}</div>
                                                            <div className='rahpardaznet-section section-two'>{section.section_two.name}</div>
                                                            <div className='rahpardaznet-section section-three'>{section.section_three.name}</div>
                                                        </div>
                                                    ))
                                                }
                                            </>
                                        ) : (
                                            <div>انباری جهت نمایش وجود ندارد.</div>
                                        )
                                    }

                                </div>

                            </div>
                            {
                                    (typeof documentData.sections == 'object' && documentData.sections.length > 0) ? (
                                        <div className='row rahpardaznet-cart rahpardaznet-main-warehouse  my-5  print-position'>

                                            <Header title='انبار اصلی' />
                                            <div className='rahpardaz-search-form-select'>
                                
                                                <select
                                                    value={MainWarehouse}
                                                    defaultValue={documentData.main_warehouse}
                                                    className='form-control form-select form-select-lg shadow-none section'
                                                    onChange={(e) => setMainWarehouse(e.target.value)}
                                                >
                                                    <option value="0" disabled>انتخاب کنید ...</option>
                                                    {
                                                        documentData.sections.map((section, key) => (
                                                            <option value={section.section_main.id}>{section.section_main.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                {
                                                    (documentData.status_document_id && documentData.status_document_id != '0' ) ? (
                                                        <button
                                                            onClick={rahpardaznetChangeStore}
                                                            type="submit"
                                                            className="print-no rahpardaznet-search-btn">
                                                            تغیر انبار

                                                        </button>
                                                    ) : null
                                                }
                                            </div>

                                        </div>
                                    ) : null
                                }
                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                {
                                    !documentData.id ? (
                                        <Header title='اطلاعات کارخانه' />
                                    )
                                        : (
                                            <Header title='اطلاعات انبار' />
                                        )
                                }
                                <div
                                    className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                    <input type="hidden" ref={mt_sanadno} value={documentData.mt_sanadno} />
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        {
                                            (documentData.mt_pelakno != '0') ? (
                                                <div
                                                    className='d-flex flex-column justify-content-center align-items-center rahpardaznet-pelak rahpardaznet-pelak-box'>
                                                    <span
                                                        ref={mt_pelakserial}>{documentData.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span ref={mt_pelakno}>
                                                        {documentData.mt_pelakno}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div className='rahpardaznet-pelakno'>
                                                    <span className="d-none"
                                                        ref={mt_pelakserial}>{documentData.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span className="d-none" ref={mt_pelakno}>
                                                        {documentData.mt_pelakno}
                                                    </span>
                                                    <span className='text-danger'>بدون پلاک</span>
                                                </div>
                                            )
                                        }

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> تاریخ نصب : </label>
                                        <span ref={mt_pelakdate}>{documentData.mt_pelakdate}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> شماره سند : </label>
                                        <span ref={mt_sanadno}>{documentData.mt_sanadno}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> شرکت: </label>
                                        <span ref={fc_coname}>{documentData.fc_coname}</span>
                                    </li>

                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع کاربری : </label>
                                        <span ref={tp_karbari}>{documentData.tp_karbari}</span>
                                    </li>

                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> سیستم : </label>
                                        <span ref={tp_system}>{documentData.tp_system}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تیپ : </label>
                                        <span ref={tp_tip}>{documentData.tp_tip}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> رنگ : </label>
                                        <span ref={cl_name}>{documentData.cl_name}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> مدل : </label>
                                        <span ref={mt_model}>{documentData.mt_model}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره بدنه : </label>
                                        <span className="font-style" ref={mt_bodyno}>
                                            {documentData.mt_bodyno}
                                        </span>
                                        <button type="button" className="rahpardaznet-copy-button"
                                            data-name="شماره بدنه" data-text={documentData.mt_bodyno}>کپی
                                        </button>

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره انجین : </label>
                                        <span className="font-style" ref={mt_motorno}>
                                            {documentData.mt_motorno}
                                        </span>

                                        <button type="button" className="rahpardaznet-copy-button"
                                            data-name="شماره انجین" data-text={documentData.mt_motorno}>کپی
                                        </button>

                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد محور : </label>
                                        <span ref={tp_mehvar}>{documentData.tp_mehvar}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد چرخ : </label>
                                        <span ref={tp_charkh}>{documentData.tp_charkh}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> ظرفیت : </label>
                                        <span ref={tp_zarfiyat}>{documentData.tp_zarfiyat}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد سیلندر : </label>
                                        <span ref={tp_cylandr}>{documentData.tp_cylandr}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع سوخت : </label>
                                        <span ref={tp_sookht}>{documentData.tp_sookht}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> حجم سیلندر : </label>
                                        <span ref={tp_hajm}>{documentData.tp_hajm}</span>
                                    </li>
                                </div>
                            </div>
                            <div className='row rahpardaznet-cart my-5 print-position'>
                                <Header title={'وضعیت  سند'} />
                                {
                                    (!documentData.status_document_id || !documentData.status_document_id == '0') ? (
                                        <div className="col-12">
                                            <div className='rahpardaz-search-form-select'>
                                                <Select
                                                    multiple={false}
                                                    key='8'
                                                    tab='8'
                                                    col='col-12'
                                                    name=''
                                                    title='وضعیت جاری سند'
                                                    value={status}
                                                    errorName={errorStatus}
                                                    onchange={(e) => setStatus(e.target.value)}
                                                    status='1'
                                                    data={statuses}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <p>این سند کارخانه از قبل ثبت شده است.</p>
                                    )
                                }

                            </div>
                            {
                                (documentData.status_document_id && documentData.status_document_id != '0' ) ? (
                                    <div className='row rahpardaznet-cart rahpardaznet-file-note my-5  print-position'>
                                        <Header title={'یادداشت و فایل ها'} />
                                        <div className="row">
                                            <div className="col-12 col-md-7 input-100">

                                                <div>
                                                    <div className="form-group rahpardaznet-small-file">
                                                        <div className="file-loading">
                                                            <input id="rahpardaznet-image-file"
                                                                type="file" name="file"
                                                                accept="image/*"
                                                                data-min-file-count="1"
                                                                multiple />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-5">
                                                <div className="container">
                                                    <div className="rahpardaznet-list-message">

                                                        {
                                                            (typeof RahpardaznetDetailsData == 'object' && RahpardaznetDetailsData.length > 0) ? (
                                                                <>
                                                                    {
                                                                        RahpardaznetDetailsData.map((note, key) => (
                                                                            <div className="message-candidate center-block">
                                                                                <div className="row rahpardaznet-message-details">
                                                                                    <div className="col-xs-8 col-md-6 p-0">
                                                                                        <h6 className="message-name"> {note.user_id}</h6>
                                                                                    </div>
                                                                                    <div className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                                        {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row message-text">
                                                                                    {note.description} ({note.description.length} کاراکتر)
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>
                                                            ) : (
                                                                <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                            )
                                                        }


                                                    </div>
                                                    <div className="messaging center-block">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className='rahpdrdaznet-border-bottom'>
                                                                    <div className="input-group">
                                                                        <input type="text" className="rahpardaznet-form-message"
                                                                            value={RahpardaznetMessage}
                                                                            onChange={(e) => setRahpardaznetMessage(e.target.value)}
                                                                            placeholder="توضیحات را وارد نمایید." />

                                                                        <button onClick={RahpardaznetSubmitMessage} className="rahpardaznet-button-send-message"
                                                                            type="button">ثبت
                                                                        </button>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='rahpardaznet-default-note-message'>
                                                                    <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۱')}>یادداشت شماره ۱</button>
                                                                    <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۲')}>یادداشت شماره ۲</button>
                                                                    <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۳')}>یادداشت شماره ۳</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }
                            {/* <div className='row rahpardaznet-cart my-5 print-position'>
                                <Header title={'بایگانی سند'}/>
                                <div className="col-6 ">
                                    <Select
                                        multiple={false}
                                        key='10'
                                        tab='10'
                                        col='col-12'
                                        name=''
                                        title='انتقال به انبار'
                                        value={transferToStore}
                                        errorName={errorTransferToStore}
                                        onchange={(e) => transferStoreHandler(e.target.value)}
                                        status='1'
                                        data={archives}
                                        defaultValue={documentData.store_id}

                                    />
                                    <Select
                                        multiple={false}
                                        key='11'
                                        tab='11'
                                        col='col-12'
                                        name=''
                                        title='طبقه بندی رده اول'
                                        value={partone}
                                        errorName={errorPartOne}
                                        onchange={(e) => sectionOneSearchHandler(e.target.value)}
                                        status='1'
                                        target='1'
                                        data={sections}
                                    />
                                </div>
                                <div className="col-6 ">
                                    <Select
                                        multiple={false}
                                        key='12'
                                        tab='12'
                                        col='col-12'
                                        name=''
                                        title='طبقه بندی رده دوم'
                                        value={parttwo}
                                        errorName={errorPartTwo}
                                        onchange={(e) => sectionTwoSearchHandler(e.target.value)}
                                        status='1'
                                        target='1'
                                        data={partOne}
                                    />
                                    <Select
                                        multiple={false}
                                        key='13'
                                        tab='13'
                                        col='col-12'
                                        name=''
                                        title='طبقه بندی رده سوم'
                                        value={partthree}
                                        errorName={errorPartThree}
                                        onchange={(e) => setPartthree(e.target.value)}
                                        status='1'
                                        data={partTwo}
                                    />
                                </div>
                            </div> */}


                            <div className="row p-0 mb-5">
                                <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto p-0">
                                    {
                                        (!documentData.status_document_id || documentData.status_document_id == '0') ? (
                                            <button
                                                tabIndex='14'
                                                onClick={documentStoreHandler}
                                                type="submit"
                                                className="print-no rahpardaznet-btn">
                                                {'تایید درخواست'}

                                            </button>
                                        ) : null
                                    }

                                </div>
                            </div>

                        </form>
                    ) : null
            }

        </>
    )
}

export default Document;